import { createApiError, ErrorContext } from '@/lib/errors/api';

import { IntentsSubmitParams, IntentsSubmitResponse } from '@/utils/intents/types';
import { routes } from '@/utils/routes';

export const submitIntentsBatch = async (
  batch: IntentsSubmitParams,
  chainId: number,
  context: ErrorContext,
): Promise<IntentsSubmitResponse> => {
  const url = routes.api.INTENTS_SUBMIT;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({ batch, chainId }),
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    throw createApiError(await response.json(), { context, status: response.status });
  }

  return (await response.json()) as IntentsSubmitResponse;
};
